export enum CannedResponseAvailability {    
    Myself = 1,
    AllAgents = 2
}